var swatches = document.querySelectorAll(".swatches > img");

var products = document.querySelectorAll(".product-grid > .grid__item");

for (let i = 0; i < swatches.length; i++) {
  swatches[i].addEventListener("click", swatchImage);
}

for (let i = 0; i < products.length; i++) {
  if (products[i].querySelector(".swatches > img")){
    products[i].querySelector(".swatches > img").click();
  }
}

function swatchImage(){
  var item = event.target;
  var currentVariantId = item.classList[0];
  var array;
  var swatches = item.parentElement.querySelectorAll("img");

  var mediaContainer = item.parentElement.parentElement.parentElement.parentElement.querySelector(".media");
  var mediaImages = mediaContainer.querySelectorAll("img");

  /*remove is-selected from swatches*/
  for (let i = 0; i < swatches.length; i++) {
    swatches[i].classList.remove("is-selected");
  }

  item.classList.add("is-selected");
  
  /*get images for selected variant*/
  for (let i = 0; i < metaData.length; i++) {
    for (let j = 0; j < metaData[i].length; j++){
      if (metaData[i][j][0] == currentVariantId){
        array = metaData[i][j][1];
      }
    }
  }

  /*change image*/
  if (array[0] != null){
    if (array[0].length > 1){
      
      var image;
      var hoverImage;

      if (array[0][0].src){
        image = array[0][0].src;
      } else {
        image = array[0][0];
      }

      if (array[0][1].src){
        hoverImage = array[0][1].src;
      } else {
        hoverImage = array[0][1];
      }

      mediaImages[0].srcset = image;

      if (mediaImages.length > 1){
        mediaImages[1].srcset = hoverImage;
      } else {
        var dup = mediaImages[0].cloneNode(true);
        dup.srcset = hoverImage;
        mediaContainer.appendChild(dup);
      }
      
    } else {
      var image;
      if (array[0][0].src){
        image = array[0][0].src;
      } else {
        image = array[0][0];
      }
      
      mediaImages[0].srcset = image;
      
      if (mediaImages.length > 1){
        mediaImages[1].remove();
      }
    }
  } else if (array[1] != null){
    var image = array[1];
    mediaImages[0].srcset = image;

    if (mediaImages.length > 1){
      mediaImages[1].remove();
    }
  } else {
    if (array[2].length > 1){
      var image = array[2][0];
      var hoverImage = array[2][1];
      
      mediaImages[0].srcset = image;

      if (mediaImages.length > 1){
        mediaImages[1].srcset = hoverImage;
      } else {
        var dup = mediaImages[0].cloneNode(true);
        dup.srcset = hoverImage;
        mediaContainer.appendChild(dup);
      }
      
    } else {
      var image = array[2][0];
      mediaImages[0].srcset = image;
      
      if (mediaImages.length > 1){
        mediaImages[1].remove();
      }
    }
  }
}